import React, { FC, useMemo } from 'react';

import { styled } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import withWidth from '@material-ui/core/withWidth';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { PathwayLogo } from '../../../../components/TestResults';
import { useTextStyles } from '../../../../utils/styles';
import Breadcrumbs from '../../../DiscoverPage/components/Breadcrumbs';
import { Header } from '../../../DiscoverPage/components/Header';
import useStyles from './styles';

interface CourseHeaderProps {
  hasAnotherCourses: boolean;
  title?: string | null;
  description?: string | null;
  circleImageUrl?: string | null;
  courseIcon?: string | null;
  courseImgUrl?: string | null;
  tenantName?: string | null;
}

const CourseHeader: FC<CourseHeaderProps> = ({
  hasAnotherCourses,
  title,
  description,
  circleImageUrl,
  courseIcon,
  courseImgUrl,
  tenantName,
}) => {
  const classes = useStyles();
  const textClasses = useTextStyles();

  const { t } = useTranslation();

  const navigationArr = useMemo(
    () => [
      {
        title: t('page.course.courses'),
        url: '/courses',
      },
      {
        title: title || '',
      },
    ],
    [t, title],
  );

  return (
    <div className={classes.wrapper}>
      <Header
        title=""
        contentWrapperClass={classes.headerWrapper}
        imageUrl={courseImgUrl || undefined}
        tenantName={tenantName}
      >
        <StyledWrapper>
          {hasAnotherCourses && (
            <Breadcrumbs wrapperClass={classes.breadcrumbsWrapper} navigation={navigationArr} />
          )}
          <div className={classes.titleWrapper}>
            <PathwayLogo
              wrapperClass={classes.logoWrapper}
              circleUrl={circleImageUrl}
              svgContent={courseIcon}
            />
            <Typography variant="h1" className={cx(textClasses.h1, classes.title)}>
              {title}
            </Typography>
          </div>
          <Typography className={cx(textClasses.introText, classes.description)}>
            {description}
          </Typography>
        </StyledWrapper>
      </Header>
    </div>
  );
};

export default withWidth()(CourseHeader);

const StyledWrapper = styled(Container)({
  paddingBottom: 0,
});
